import type { WithActiveBranchId } from '@app/api/shared';

export enum ExpenseArticlesEndpoints {
  UpdateExpenseArticle = 'UpdateExpenseArticle',
  GetExpenseArticles = 'GetExpenseArticles',
}

export interface ModelExpenseArticle {
  Id: number;
  Name: string | null;
  Description: string | null;
  IsDeleted: boolean;
}

export interface UpdateExpenseArticleRequest extends WithActiveBranchId {
  data: Omit<ModelExpenseArticle, 'Id'> & {
    Id?: ModelExpenseArticle['Id'];
  };
}

export interface GetExpenseArticlesRequest extends WithActiveBranchId {
  isOnlyActive?: boolean;
}

export type UpdateExpenseArticleResponse = ModelExpenseArticle;
export type GetExpenseArticlesResponse = ModelExpenseArticle[];
